export default "__VITE_ASSET__BTiLkONL__"